import { render } from "./ManageAdmin.vue?vue&type=template&id=621e6d66&scoped=true"
import script from "./ManageAdmin.vue?vue&type=script&lang=js"
export * from "./ManageAdmin.vue?vue&type=script&lang=js"

import "./ManageAdmin.vue?vue&type=style&index=0&id=621e6d66&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621e6d66"]])

export default __exports__